/* eslint-disable prettier/prettier */
import React from 'react';
import { useAsyncEffect } from 'ahooks';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { Image } from 'antd';
import { useAtom } from 'jotai';
import { ShowModal } from '@/model';
import { request } from '@/config/request';
import { ActivityAreaVO } from '@/service/market';
import { isLogin, toLogin, checkLogin } from '@/config/request/login';
import { BACK_UP_IMG } from '@/const/staticURL';
import { urlAddChannel } from '@/utils';
import styles from './index.module.scss';
const ActivePlate: React.FC = () => {
  const navigate = useNavigate();
  const login = isLogin();
  const [, writeShowModal] = useAtom(ShowModal.showModal);
  const [activityAreaVO, setactivityAreaVO] = React.useState<ActivityAreaVO[]>([]);
  useAsyncEffect(async () => {
    try {
      const res = await request.market.activity.areaList({
        bizScene: '1',
        sourceChannel: '1'
      });
      if (res?.data?.length) {
        setactivityAreaVO(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);
  const goGoodsList = (item: ActivityAreaVO) => {
    navigate({
      pathname: '/hotSellingList',
      search: `?${createSearchParams({
        moduleName: String(item.moduleName || ''),
        moduleDesc: String(item.moduleDesc || ''),
        areaId: String(item.id || '')
      })}`
    });
  };
  const goGoodsDetail = async (productCode?: string) => {
    const islogin = await checkLogin();
    if (islogin) {
      const url = `/goods?productCode=${productCode}`;
      // window.open(url, '_blank');
      window.open(urlAddChannel(url));
    } else {
      // window.location.href = toLogin();
      writeShowModal(true);
    }
  };
  return <div className={styles.container}>
            {activityAreaVO.map((item, index) => <div key={index} className={styles.plate} style={{
      width: activityAreaVO.length === 1 ? '100%' : '592px'
    }}>
                    <div className={styles.wrap}>
                        <div className={styles.title}>
                            <div className={styles.name}>{item.moduleName}</div>
                            <span className={styles.desc}>
                                {item.moduleDesc}
                            </span>
                        </div>
                        <a className={styles.more} onClick={() => goGoodsList(item)}>
                            {window._$m.t('更多 >')}
                        </a>
                    </div>

                    <div className={styles.list}>
                        {item.topProductList?.filter((i, index) => index < (activityAreaVO.length === 1 ? 6 : 3) && !!i).map((product, productIndex) => <div key={product.productCode} className={styles.goods} onClick={() => goGoodsDetail(product?.productCode)}>
                                    <div className={styles.imgBox}>
                                        <Image className={styles.img} width={180} preview={false} fallback={BACK_UP_IMG} src={product?.productMainImg} alt="" />
                                    </div>
                                    <div className={styles.name}>
                                        {product?.productTitle}
                                    </div>
                                    {login ? <div className={styles.tagPrices}>
                                            <div className={styles.tag}>
                                                {item.priceDesc || ''}
                                            </div>
                                            <div className={styles.prices}>
                                                {product?.productLowestPrice}
                                                {window._$m.t('円')}
                                            </div>
                                        </div> : <div className={styles.unloginText}>
                                            {window._$m.t('免费注册查看价格')}
                                        </div>}
                                </div>)}
                    </div>
                </div>)}
        </div>;
};
export default ActivePlate;